const users = [
  {
    CustomerID: 6277,
    CustomerCode: "RAVC0006277",
    AssociateCode: "11111111",
    Solutation: "Mrs.",
    CustomerName: "PRIYA GARG",
    CustomerType: "Y",
    Password: "wi5PxKca3aw=",
    PrimaryMobile: "9871895939",
    WhatsappNo: "9871895939",
    EmailID: "relianceabcpl@gmail.com",
    DOB: "12-05-1992",
    MaritalStatus: "UnMarried",
    PincodeP: "110032",
    CityP: "NORTH EAST DELHI",
    StateP: "DELHI",
    CountryP: "INDIA",
    AddressP: "1/3555, FIRST FLOOR, RAM NAGAR",
    KYCStatus: "N",
    Status: "Y",
    ProfileImage: "user1.jpg",
    ProfileFilePath:
      "https://erp.ravbiz.in/UploadFile_Test/PropertyFile/custProfile/",
    CreatedOn: "17-12-2021",
  },
  {
    CustomerID: 6278,
    CustomerCode: "RAVC0006278",
    AssociateCode: "11111111",
    Solutation: "Mr.",
    CustomerName: "AMIT SHARMA",
    CustomerType: "Y",
    Password: "xP9zKca3aw=",
    PrimaryMobile: "9810234567",
    WhatsappNo: "",
    EmailID: "amit.sharma@example.com",
    DOB: "22-08-1988",
    MaritalStatus: "Married",
    PincodeP: "110001",
    CityP: "NEW DELHI",
    StateP: "DELHI",
    CountryP: "INDIA",
    AddressP: "H-42, Connaught Place",
    KYCStatus: "Y",
    Status: "Y",
    ProfileImage: "user2.jpg",
    ProfileFilePath:
      "https://erp.ravbiz.in/UploadFile_Test/PropertyFile/custProfile/",
    CreatedOn: "05-01-2022",
  },
  {
    CustomerID: 6279,
    CustomerCode: "RAVC0006279",
    AssociateCode: "22222222",
    Solutation: "Ms.",
    CustomerName: "SNEHA KAPOOR",
    CustomerType: "N",
    Password: "vR4mQca3aw=",
    PrimaryMobile: "9958473621",
    WhatsappNo: "9958473621",
    EmailID: "sneha.k@ravbiz.in",
    DOB: "15-03-1995",
    MaritalStatus: "UnMarried",
    PincodeP: "400001",
    CityP: "MUMBAI",
    StateP: "MAHARASHTRA",
    CountryP: "INDIA",
    AddressP: "Plot 12, Marine Drive",
    KYCStatus: "N",
    Status: "Y",
    ProfileImage: "user3.jpg",
    ProfileFilePath:
      "https://erp.ravbiz.in/UploadFile_Test/PropertyFile/custProfile/",
    CreatedOn: "20-02-2022",
  },
  {
    CustomerID: 6280,
    CustomerCode: "RAVC0006280",
    AssociateCode: "11111111",
    Solutation: "Mr.",
    CustomerName: "VIKRAM SINGH",
    CustomerType: "Y",
    Password: "bT2pLca3aw=",
    PrimaryMobile: "9811002233",
    WhatsappNo: "",
    EmailID: "vikram.s@gmail.com",
    DOB: "10-10-1985",
    MaritalStatus: "Married",
    PincodeP: "302001",
    CityP: "JAIPUR",
    StateP: "RAJASTHAN",
    CountryP: "INDIA",
    AddressP: "Sector 5, Mansarovar",
    KYCStatus: "Y",
    Status: "Y",
    ProfileImage: "user4.jpg",
    ProfileFilePath:
      "https://erp.ravbiz.in/UploadFile_Test/PropertyFile/custProfile/",
    CreatedOn: "12-03-2022",
  },
  {
    CustomerID: 6281,
    CustomerCode: "RAVC0006281",
    AssociateCode: "33333333",
    Solutation: "Mrs.",
    CustomerName: "POOJA VERMA",
    CustomerType: "Y",
    Password: "nM8kXca3aw=",
    PrimaryMobile: "8800112233",
    WhatsappNo: "8800112233",
    EmailID: "pooja.v@outlook.com",
    DOB: "01-07-2026",
    MaritalStatus: "Married",
    PincodeP: "560001",
    CityP: "BENGALURU",
    StateP: "KARNATAKA",
    CountryP: "INDIA",
    AddressP: "Apt 204, Whitefield",
    KYCStatus: "N",
    Status: "Y",
    ProfileImage: "user5.jpg",
    ProfileFilePath:
      "https://erp.ravbiz.in/UploadFile_Test/PropertyFile/custProfile/",
    CreatedOn: "18-04-2022",
  },
  // Generated Users 6 to 50
  ...Array.from({ length: 45 }, (_, i) => {
    const id = 6282 + i;
    const names = [
      "Rahul",
      "Anjali",
      "Suresh",
      "Meena",
      "Deepak",
      "Kavita",
      "Rohan",
      "Sunita",
      "Arjun",
      "Preeti",
    ];
    const cities = [
      "LUCKNOW",
      "PUNE",
      "CHENNAI",
      "KOLKATA",
      "HYDERABAD",
      "AHMEDABAD",
      "SURAT",
    ];
    const states = [
      "UTTAR PRADESH",
      "MAHARASHTRA",
      "TAMIL NADU",
      "WEST BENGAL",
      "TELANGANA",
      "GUJARAT",
    ];

    return {
      CustomerID: id,
      CustomerCode: `RAVC000${id}`,
      AssociateCode: (11111111 + i).toString(),
      Solutation: i % 2 === 0 ? "Mr." : "Mrs.",
      CustomerName:
        `${names[i % names.length]} ${["Kumar", "Singh", "Jain", "Patel", "Reddy"][i % 5]}`.toUpperCase(),
      CustomerType: i % 3 === 0 ? "N" : "Y",
      Password: "encodedPassword==",
      PrimaryMobile: `9${Math.floor(100000000 + Math.random() * 900000000)}`,
      WhatsappNo: i % 4 === 0 ? "" : "9000000000",
      EmailID: `user${id}@ravbiz.in`,
      DOB: "01-01-1990",
      MaritalStatus: i % 2 === 0 ? "Married" : "UnMarried",
      PincodeP: (110000 + i).toString(),
      CityP: cities[i % cities.length],
      StateP: states[i % states.length],
      CountryP: "INDIA",
      AddressP: `Street No. ${i + 1}, Main Market`,
      KYCStatus: i % 5 === 0 ? "N" : "Y",
      Status: i % 10 === 0 ? "N" : "Y",
      ProfileImage: `user${(i % 5) + 1}.jpg`,
      ProfileFilePath:
        "https://erp.ravbiz.in/UploadFile_Test/PropertyFile/custProfile/",
      CreatedOn: `${10 + (i % 20)}-05-2022`,
    };
  }),
];

export default users;
